








import { Vue, Component } from 'vue-property-decorator';
import NotFoundPage from '@/components/Form/PartnerNotFound/NotFoundPage/index.vue';

@Component({
  components: {
    NotFoundPage,
  },
})
export default class PartnerNotFound extends Vue {
}
